import type { FormDocument, FieldOption } from '@fulcrum/form-embedded';

// Demo clinical content lives in the host, not the library — the embedded
// component only knows how to render/author a FormDocument; the host owns
// what forms exist, same as it owns all other persisted data.

const SECTION_ID = 'phq9-section';

const LIKERT_OPTIONS: FieldOption[] = [
  { id: 'o0', value: '0', label: 'Not at all', order: 0, weight: 0 },
  { id: 'o1', value: '1', label: 'Several days', order: 1, weight: 1 },
  { id: 'o2', value: '2', label: 'More than half the days', order: 2, weight: 2 },
  { id: 'o3', value: '3', label: 'Nearly every day', order: 3, weight: 3 },
];

const ITEM_TEXT: string[] = [
  'Little interest or pleasure in doing things',
  'Feeling down, depressed, or hopeless',
  'Trouble falling or staying asleep, or sleeping too much',
  'Feeling tired or having little energy',
  'Poor appetite or overeating',
  'Feeling bad about yourself — or that you are a failure, or have let yourself or your family down',
  'Trouble concentrating on things, such as reading the newspaper or watching television',
  'Moving or speaking so slowly that other people could have noticed — or the opposite, being so fidgety or restless that you have been moving around a lot more than usual',
  'Thoughts that you would be better off dead or of hurting yourself in some way',
];

export const PHQ9_DOCUMENT: FormDocument = {
  sections: [
    {
      id: SECTION_ID,
      name: 'PHQ-9',
      label: 'PHQ-9 Depression Screener',
      description: 'Over the last 2 weeks, how often have you been bothered by any of the following problems?',
      order: 0,
      fields: [
        ...ITEM_TEXT.map((text, i) => ({
          id: `phq9-q${i + 1}`,
          sectionId: SECTION_ID,
          label: `${i + 1}. ${text}`,
          handle: `phq${i + 1}`,
          fieldType: 'SCALE',
          order: i,
          isRequired: true,
          isHidden: false,
          options: LIKERT_OPTIONS,
          clinicalCoding: i === 0 ? { loincCode: '44249-1' } : undefined,
        })),
        {
          id: 'phq9-total',
          sectionId: SECTION_ID,
          label: 'Total Score',
          handle: 'phq9_total',
          fieldType: 'CALC',
          order: ITEM_TEXT.length,
          isRequired: false,
          isHidden: false,
          calc: { aggregation: 'sum', sourceHandles: Array.from({ length: 9 }, (_, i) => `phq${i + 1}`) },
          clinicalCoding: { loincCode: '44261-6' },
        },
      ],
    },
  ],
};
